/* ------ ADD TO CART ------ */
// used on PLP atc button
document.addEventListener("click", function (e) {

    const btn = e.target.closest(".add-to-cart");
    if (!btn) return; // not an add-to-cart button

    const variantId = Number(btn.getAttribute("data-variant-id"));
    const metaText = btn.getAttribute("data-variant-lineitem");

    const data = {
        id: variantId,
        quantity: 1,
        properties: {}
    };

    // Add metafield value as a line item property if it exists
    if (metaText && metaText.trim() !== "") {
        data.properties["ships_on"] = metaText;
    }

    // Shopify AJAX add to cart
    fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    })
    .then((res) => res.json())
    .then(() => {
        AMP_API.OPEN_CART(); // your theme’s cart-opening function
    })
    .catch((error) => {
        console.error("Error adding product to cart:", error);
    });
});

/* ------ AMP CART ------ */
if (!document.body.classList.contains('collection-template')) {
  (function() {
    const originalFetch = window.fetch;
    window.fetch = async function(...args) {
      const response = await originalFetch.apply(this, args);
      const requestUrl = args[0];
      if (typeof requestUrl === 'string' && requestUrl.includes('/cart/add.js')) {
        response.clone().json().then((data) => {
          onProductAddedToCart(data);
        }).catch((err) => {
          console.error('Error reading /cart/add.js response:', err);
        });
      }
      return response;
    };
    // Define the function outside so it can be called in fetch interceptor
    function onProductAddedToCart(data) {
      AMP_API.OPEN_CART();
    }
    // Check if any div with class 'amp-cart' also has class 'amp-cart--open'
    const ampCart = document.querySelector('div.amp-cart');
  })();
}

/* ------ AMP CART UPDATE FUNCTIONS ------ */
window.AMP_CART_UPDATED = function(updatedCart) {
// AMP CART COUNTER UPDATE
  const cartCountEl = document.querySelector('cart-count');
  if (cartCountEl) {
    const item_count = document.querySelectorAll('.amp-cart__cart-line').length;
    // Update the inner text
    if (item_count > 99) {
      cartCountEl.innerHTML = `<span class="text-sm">99+</span>`;
      cartCountEl.classList.add('cart-count--small-medium');
    } else {
      cartCountEl.textContent = item_count;
      cartCountEl.classList.remove('cart-count--small-medium');
    }
    // Update aria-label
    cartCountEl.setAttribute('aria-label', `${item_count} item${item_count === 1 ? '' : 's'}`);
    // Show or hide the element based on count
    cartCountEl.hidden = item_count === 0;
    // Add or remove the global class on <html>
    const method = item_count === 0 ? 'remove' : 'add';
    document.documentElement.classList[method]('cart-has-items');
  }
};

/* ------ Header hide after Xpx ------ */
/* ------ Header hide after Xpx, works with sections above header ------ */
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.header-sticky');
  if (!header) return;

  // Function to get all .shopify-section elements above the header
  function getSectionsAboveHeader() {
    return Array.from(document.querySelectorAll('.shopify-section'))
      .filter(section => section.compareDocumentPosition(header) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  // Function to calculate total height of sections above header
  function calculateHeight(sections) {
    return sections.reduce((sum, section) => sum + section.clientHeight, 0);
  }

  let sectionsAboveHeader = getSectionsAboveHeader();
  let height = calculateHeight(sectionsAboveHeader);

  let lastScrollY = window.scrollY;
  let lastDirection = 0; // 1 = down, -1 = up
  let ticking = false;
  const threshold = 5; // Ignore tiny scrolls

  function updateHeader() {
    const currentScrollY = window.scrollY;

    // --- iPHONE SAFARI FIX: At top, always show header ---
    if (currentScrollY === 0) {
      header.style.marginTop = `${height}px`;
      header.style.top = `${height}px`;
      sectionsAboveHeader.forEach(sec => sec.classList.add('show__scroller'));
      header.classList.remove('header-hidden');

      lastScrollY = 0;
      lastDirection = -1;
      ticking = false;
      return;
    }
    // ------------------------------------------------------

    const diff = currentScrollY - lastScrollY;

    if (Math.abs(diff) > threshold) {
      const direction = diff > 0 ? 1 : -1;

      if (direction !== lastDirection) {
        if (direction === 1) {
          // Scrolling down → hide header
          header.classList.add('header-hidden');
          header.style.marginTop = 0;
          header.style.top  = 0;
          sectionsAboveHeader.forEach(sec => sec.classList.remove('show__scroller'));
        } else {
          // Scrolling up → show header
          header.style.marginTop = `${height}px`; 
          header.style.top = `${height}px`; 
          sectionsAboveHeader.forEach(sec => sec.classList.add('show__scroller'));
          header.classList.remove('header-hidden');
        }
        lastDirection = direction;
      }

      lastScrollY = currentScrollY;
    }

    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  });

  // Recalculate sections and height on resize
  window.addEventListener('resize', () => {
    sectionsAboveHeader = getSectionsAboveHeader();
    height = calculateHeight(sectionsAboveHeader);

    // Ensure header is correctly positioned if currently visible
    if (!header.classList.contains('header-hidden')) {
      header.style.marginTop = `${height}px`;
      header.style.top = `${height}px`;
      sectionsAboveHeader.forEach(sec => sec.classList.add('show__scroller'));
    }
  });
});


/* ------ HP VIDEO HERO ------ */
function setHeroHeight() {
  var viewportHeight = window.innerHeight;
  // Set height attribute of all <video> elements
  document.querySelectorAll('video').forEach(function(video) {
    video.setAttribute('height', viewportHeight);
  });
  // Set CSS height of all <video-element> elements
  document.querySelectorAll('video-element').forEach(function(el) {
    el.style.height = viewportHeight + 'px';
  });
  // Remove specific classes from all <motion-element> elements with class 'media'
  document.querySelectorAll('motion-element.media').forEach(function(el) {
    el.classList.remove('media', 'media--adapt', 'mb:media--adapt');
  });
}
document.addEventListener('DOMContentLoaded', function() {
  if (document.body.classList.contains('index-template')) {
    setHeroHeight();
    window.addEventListener('resize', setHeroHeight);
  }
});

/* ------ GORGIAS ------ */
  //Hide Gorgias and show on scroll
  //if (document.body.classList.contains('index-template')) {
    window.addEventListener("scroll", function () {
      const gcc = document.getElementById("gorgias-chat-container");
      if (gcc) {
        if (window.scrollY > 100) {
          gcc.style.display = "block";
        } else {
          gcc.style.display = "none";
        }
      }
    });
  //}

/* ------ FOOTER ------ */
// Cookies Bar
document.addEventListener("DOMContentLoaded", function () {
  // Check cookie on page load
  var check_cookie = sessionStorage.getItem("close_cookie");
  var cookieConsentDiv = document.getElementById("cookie_consent");

  if (check_cookie !== 'closed') {
    cookieConsentDiv.style.display = 'block';
  } else {
    cookieConsentDiv.style.display = 'none';
  }

  // Add click listener to the button
  var closeButton = document.getElementById("cbtnc_beast");
  closeButton.addEventListener("click", function () {
    sessionStorage.setItem("close_cookie", "closed");
    cookieConsentDiv.style.display = 'none';
  });

  // Load AccessiBe script
  (function () {
    const s = document.createElement('script');
    const h = document.querySelector('head') || document.body;
    s.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
    s.defer = true;
    s.onload = function () {
      const initAccessiBe = () => {
        const customTrigger = document.querySelector('.acc__link');
        const realTrigger = document.querySelector('.acsb-trigger');

        if (customTrigger && typeof acsbJS === 'object' && typeof acsbJS.init === 'function') {

          acsbJS.init({
            statementLink: 'https://thebeast.com/pages/accessibility',
            hideTrigger: true,
            disableBgProcess: false,
            language: 'en',
            position: 'left',
            leadColor: '#121212',
            triggerColor: '#121212',
            triggerRadius: '50%',
            triggerPositionX: 'right',
            triggerPositionY: 'bottom',
            triggerIcon: 'people',
            triggerSize: 'medium',
            triggerOffsetX: 20,
            triggerOffsetY: 20,
            mobile: {
              triggerSize: 'small',
              triggerPositionX: 'right',
              triggerPositionY: 'bottom',
              triggerOffsetX: 10,
              triggerOffsetY: 10,
              triggerRadius: '50%'
            }
          });

          const waitForRealTrigger = setInterval(() => {
            const realTrigger = document.querySelector('.acsb-trigger');
            if (realTrigger) {
              //console.log("✅ Real AccessiBe trigger found — wiring custom click");
              realTrigger.style.display = 'none'; // hide widget
              customTrigger.addEventListener('click', function (e) {
                e.preventDefault();
                realTrigger.click();
              });
              clearInterval(waitForRealTrigger);
            }
          }, 100);

          clearInterval(waitInit);
        }
      };

      const waitInit = setInterval(initAccessiBe, 100);
    };
    h.appendChild(s);
  })();

});

/* ------ PLP ------ */
  // Script to replace the swatch click from redirect to rather display the variant image
  $('body').on('click', '.product-card__swatches ul.swatches--product-card li', function(event) {
    event.preventDefault();

    // Get the ATC button
    var atcButton = $(this).closest('.product-card').find('button.add-to-cart');
    // Get the swatch variant ID
    var variantId = $(this).data('variant-id');
    atcButton.attr('data-variant-id', variantId);
    // Get the swatch availability 
    let variantStock = $(this).data('stock');

    // Get the new image paths for primary and secondary images
    var getswatch = $(this).data('variant-img');
    var getswatchhover = $(this).data('variant-hover');
    
    // Cache the product card and images
    var $productCard = $(this).closest('.product-card');
    var $pImage = $productCard.find('.product-card__image--main img');
    var $sImage = $productCard.find('.product-card__image--second img');
    
    // Get current src and srcset for primary and secondary images
    var primarySrc = $pImage.attr('src');
    var primarySrcset = $pImage.attr('srcset');
    var secondarySrc = $sImage.attr('src');
    
    // Update the image sources
    var newPSrc = primarySrc.replace(/files\/[^?]+/, '/' + getswatch);
    var newPSrcset = primarySrcset ? primarySrcset.replace(/files\/[^?]+/g, '/' + getswatch) : null;
    var newSSrc = secondarySrc.replace(/\/([^\/]+)(\?v=[^&]+)/, '/'+ getswatchhover + '$2');

    // Set the updated src and srcset back to the images
    $pImage.attr('src', newPSrc);
    if (newPSrcset) {
      $pImage.attr('srcset', newPSrcset);
    }

    $sImage.attr('src', newSSrc);
    if (getswatchhover) {
      // Generate srcset for secondary image
      const baseSSrc = newSSrc.split('?')[0];
      const querySSrc = newSSrc.includes('?') ? newSSrc.split('?')[1] + '&' : '';
      
      const newSSrcset = `
        ${baseSSrc}?${querySSrc}width=270 270w,
        ${baseSSrc}?${querySSrc}width=450 450w,
        ${baseSSrc}?${querySSrc}width=600 600w
      `;
      
      $sImage.attr('srcset', newSSrcset.trim());
    } else {
      // If no hover image provided, fallback to primary srcset
      $sImage.attr('srcset', newPSrcset);
    }

    if(variantStock == false ) {
      atcButton.prop('disabled', true).text('Out of Stock');
    } else {
      atcButton.prop('disabled', false).text('Add to Cart');
    }
  });

// Add to Cart on button click
document.body.addEventListener('click', function(event) {
  // Check if the clicked element matches the selector '.product-card button.add-to-cart'
  if (event.target.matches('.product-card button.add-to-cart')) {
    event.preventDefault();

    const button = event.target;
    // Find closest .product-card ancestor
    const productCard = button.closest('.product-card');
    if (!productCard) return;

    // Find the add-to-cart button inside that product card (usually it's the same button clicked)
    const atcButton = productCard.querySelector('button.add-to-cart');

    // Get data attributes from clicked button
    const variantId = button.getAttribute('data-variant-id');
    // dataset property parses data attributes; but beware false might be string
    const variantStock = button.getAttribute('data-stock');

    // Check if variantStock is not false (assuming it's a string)
    if (variantStock !== 'false') {
      addToCart(variantId, 1);
    }
  }
});

/* ------ ACCESSORIES ------ */
  $(document).ready(function() {
    $('.collection-template.accessories #ProductCount').text('0 products');
    $('#acc_select').change(function() {
      let selectedOption = $('#acc_select option:selected');
      let selectedDataTag = selectedOption.data('tag');
      let selectedTitle = selectedOption.text();
  
      $('#ProductGridContainer .f-column').show();
  
      $('#ProductGridContainer .f-column').each(function() {
        let tags = $(this).attr('data-tag'); // raw string, e.g. "acc_all,acc_go,acc_mega"
        
        // Check if selectedDataTag is included
        if (!tags || !tags.includes(selectedDataTag)) {
          $(this).hide();
        }
      });
  
      let visibleCount = $('#ProductGridContainer .f-column:visible').length;
      $('.collection-template.accessories #ProductCount').text(visibleCount + ' products');

      if (selectedTitle.includes('Select')) {
        $('.accessories_title').hide();
      } else {
        $('.accessories_title').fadeIn();
        $('.accessories_title h3').text('Shop ' + selectedTitle + ' Accessories');
      }
    });
  });


/* ------ PDP ------ */
  // Bundle Switcher
  document.addEventListener('DOMContentLoaded', () => {
    const dropdown = document.getElementById('product-bundle');
    const toggle = document.getElementById('bundle-toggle');
    const list = dropdown.querySelector('ul');
    const items = dropdown.querySelectorAll('li input[type="radio"]');

    // Handle the radio reorder behavior
    items.forEach(input => {
      input.addEventListener('click', (e) => {
        e.preventDefault();
        const link = input.parentElement.getAttribute('href');
        // Redirect after a short delay
        setTimeout(() => {
          window.location.href = link;
        }, 80);
      });
    });

    // Toggle dropdown open/close
    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      dropdown.classList.toggle('open');
    });

    // Handle dropdown item clicks (non-radio version)
    const lis = dropdown.querySelectorAll('li');
    lis.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const title = item.dataset.title;
        const url = item.dataset.url;

        // Update visible label
        toggle.textContent = title;

        // Mark active
        lis.forEach(li => li.classList.remove('active_bundle'));
        item.classList.add('active_bundle');

        // Close dropdown smoothly
        dropdown.classList.remove('open');

        // Redirect after animation
        setTimeout(() => {
          window.location.href = url;
        }, 300);
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove('open');
      }
    });
  });

// Custom notice (Ship on data)
  window.addEventListener('load', function () {
    var custom_line_item = $('.product__block--variant_picker .color_wrap input[type="radio"]:checked').attr('custom');

    // Create container if it doesn't exist
    if (!$('.product__block--line-item').length) {
      $('<div class="product__block product__block--line-item"></div>')
        .insertBefore('.product__block--buy_buttons');
    }

    // Set content and show/hide
    if (custom_line_item && custom_line_item.length >= 2) {
      $('.product__block--line-item')
        .html(custom_line_item)
        .show();
    } else {
      $('.product__block--line-item')
        .hide()
        .empty();
    }
  });

  $(document).on('change', '.product__block--variant_picker .color_wrap input[type="radio"]', function () {
    var custom_line_item = $(this).attr('custom');

    if (custom_line_item && custom_line_item.length >= 2) {
      $('.product__block--line-item')
        .html(custom_line_item)
        .show();
    } else {
      $('.product__block--line-item')
        .hide()
        .empty();
    }
  });


// Description limit height (Show/Hide)
  const maxPreviewHeight = 130;
  $('.product__block[data-block="description"] .accordion-details__content').each(function () {
    const $content = $(this);
    $content.wrap('<div class="accordion-details__content-wrapper"></div>');
    
    const $wrapper = $content.parent();
    
    if ($content[0].scrollHeight > maxPreviewHeight) {
      $wrapper.after('<span class="read-more-toggle">Show more</span>');
    }
  });

  $(document).on('click', '.read-more-toggle', function () {
    const $btn = $(this);
    const $wrapper = $btn.prev('.accordion-details__content-wrapper');
    const isExpanded = $wrapper.toggleClass('expanded').hasClass('expanded');

    $btn.text(isExpanded ? 'Show less' : 'Show more');
  });

  // Beast Compare Blenders
  window.addEventListener('load', function() {
    var colcount = $('.beast_compare_col').length;
    if ( colcount == '1' ) {
      $('#beast_compare').addClass('one_ccol').show();
    } else if (colcount != '1'){
      $('#beast_compare').addClass('two_ccol').show();
    };
    
    var columns = document.querySelectorAll('.beast_compare_col');

    // Beast Compare Blenders - Set product images
    $('#beast_compare .cb_img').hide();
    $(".beast_compare_col").each(function() {
      var def_col = $('.beast_color_block:first', this).data('swatch');

      $(this).find('.cb_img').filter(function() {
          return $(this).data('color') === def_col;
      }).show();
    
      $(this).find('.beast_color_block').filter(function() {
          return $(this).data('swatch') === def_col; 
      }).addClass('ccolur_actv');
    });

    // Beast Compare Blenders - color swatch select
    $('.beast_color_block').click(function(){
      $('.beast_compare_col').removeClass('actv_col');
      $(this).closest('.beast_compare_col').addClass('actv_col');
      $('.actv_col .beast_color_block').removeClass('ccolur_actv');
      $(this,'.actv_col .beast_color_block').addClass('ccolur_actv');
      var sel_swatch = $(this).data('swatch');
      // clear other images
      $('.actv_col .cb_img').hide();
      $('.actv_col .cb_img').filter(function() {
        return $(this).data('color') && $(this).data('color').includes(sel_swatch);
      }).fadeIn();
      
    });  
    
    // Find the number of rows (based on grid_line items per column)
    var rows = columns[0].querySelectorAll('.grid_line').length;
    
    // Loop through each row and equalize the height of grid lines across columns
    for (var rowIndex = 0; rowIndex < rows; rowIndex++) {
      var maxHeight = 0;
      
      // Find all grid lines in the current row (across all columns)
      var rowLines = Array.from(columns).map(function(col) {
        return col.querySelectorAll('.grid_line')[rowIndex];
      });
      
      // Find the max height of this row
      rowLines.forEach(function(line) {
        maxHeight = Math.max(maxHeight, line.offsetHeight);
      });
      
      // Set all grid lines in this row to the max height
      rowLines.forEach(function(line) {
        line.style.height = maxHeight + 'px';
      });
    }
  });

  const select1 = document.getElementById('compare_1_select');
  const select2 = document.getElementById('compare_2_select');
  const select3 = document.getElementById('compare_3_select');

  // Function to update options visibility
  function updateSelectOptions() {
    const selected1 = select1.value;
    const selected2 = select2.value;
    const selected3 = select3.value;
    
    if ($(window).width() > 768) {
      // Disable options that are selected in the other selects
      Array.from(select1.options).forEach(option => {
        option.disabled = [selected2, selected3].includes(option.value);
      });
      Array.from(select2.options).forEach(option => {
        option.disabled = [selected1, selected3].includes(option.value);
      });
      Array.from(select3.options).forEach(option => {
        option.disabled = [selected1, selected2].includes(option.value);
      });
    }
  }

  // Beast Compare Blenders - Event listeners for both select elements
  select1.addEventListener('change', updateSelectOptions);
  select2.addEventListener('change', updateSelectOptions);
  select3.addEventListener('change', updateSelectOptions);

  // Beast Compare Blenders - Initial call to set the correct disabled options when the page loads
  updateSelectOptions();

  // Beast Compare Blenders - set default selection
  $(document).ready(function() {
    if ($(window).width() > 768) {
      $('#compare_1_select option:eq(0)').prop('selected', true);
      $('#compare_2_select option:eq(1)').prop('selected', true);
      $('#compare_3_select option:eq(2)').prop('selected', true);
    } else {
      $('#compare_1_select option:eq(0)').prop('selected', true);
      $('#compare_2_select option:eq(1)').prop('selected', true);
      $('#compare_3_select option:eq(2)').prop('selected', false);
      $('#compare_3_select').hide();
    
      const default1 = $('#compare_1_select').val();
      const default2 = $('#compare_2_select').val();
    
      $('#compare_2_select option').prop('disabled', false);
      $('#compare_2_select option[value="' + default1 + '"]').prop('disabled', true);
    
      $('#compare_1_select option').prop('disabled', false);
      $('#compare_1_select option[value="' + default2 + '"]').prop('disabled', true);
    };

    // Beast Compare Blenders - Trigger updateSelectOptions after setting default values
    updateSelectOptions();

    function hidecompare() {
      const divs = document.querySelectorAll('.beast_compare_col');
      var selv_1 = $('#compare_1_select').val();
      var selv_2 = $('#compare_2_select').val();
      var selv_3 = $('#compare_3_select').val();
    
      divs.forEach(div => {
        const productID = div.getAttribute('data-prod');
        if ($(window).width() > 768) {
          if (productID !== selv_1 && productID !== selv_2 && productID !== selv_3) {
            $(div).hide(); 
          } else {
            $(div).show(); 
          }
        } else {
          if (productID !== selv_1 && productID !== selv_2) {
            $(div).hide();
          } else {
            $(div).show();
          }
        }
      });
    };
    
    // Beast Compare Blenders - On change
    if ($(window).width() > 768) {
      $('#compare_1_select').change(function() {
        hidecompare();
        var selprod1 = $('#compare_1_select').val();
        $('.beast_compare_col[data-prod="'+ selprod1 +'"]').css('order','0').show();
      });
      
      $('#compare_2_select').change(function() {
        hidecompare();
        var selprod2 = $('#compare_2_select').val();
        $('.beast_compare_col[data-prod="'+ selprod2 +'"]').css('order','1').show();
      });
      
      $('#compare_3_select').change(function() {
        hidecompare();
        var selprod3 = $('#compare_3_select').val();
        $('.beast_compare_col[data-prod="'+ selprod3 +'"]').css('order','2').show();
      });
    } else {
      $('#compare_1_select').change(function() {
        hidecompare();
        var selprod1 = $(this).val();
        $('.beast_compare_col[data-prod="' + selprod1 + '"]').css('order', '0').show();
    
        // Disable selected value in compare_2_select
        $('#compare_2_select option').prop('disabled', false);
        $('#compare_2_select option[value="' + selprod1 + '"]').prop('disabled', true);
      });
    
      $('#compare_2_select').change(function() {
        hidecompare();
        var selprod2 = $(this).val();
        $('.beast_compare_col[data-prod="' + selprod2 + '"]').css('order', '1').show();
    
        // Disable selected value in compare_1_select
        $('#compare_1_select option').prop('disabled', false);
        $('#compare_1_select option[value="' + selprod2 + '"]').prop('disabled', true);
      });
    }
  });
